import { color as d3Color } from 'd3-color'

export class Color {
  css: string
  gl: [number, number, number, number]

  constructor(colorString: string) {
    this.css = colorString

    const parsed = d3Color(colorString).rgb()
    this.gl = [parsed.r / 255, parsed.g / 255, parsed.b / 255, parsed.opacity]
  }
}
